export const ORGANIZATION_TERMS_STATUS_TAG = { type: 'ORGANIZATION_TERMS_STATUS', id: 'LIST' } as const

export const DISPLAY_MODES = {
  POPUP: 'popup',
  BANNER: 'banner',
} as const
